import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';

@Component
export default class MarketingWatchPage extends Vue {
    public images: string[] = [];
    public lang: string | null = null;
    public configs = new CommonConfig();

    public async created() {

    }

    public mounted() {
    }
}
